import MuiDialogContent from "@mui/material/DialogContent";

export default function DialogContent(props) {
  return <MuiDialogContent {...props} />;
}
